import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { ReactSVG, useTranslation } from '~/dependencies';
import { colors } from '~/layout';
import { ActionButtons, Button, Dialog, DialogContent } from './styles';

type ConfirmationBoxProps = {
  open: boolean;
  close: () => void;
  title: string;
  icon: any;
  isLoading: boolean;
  handleAction: () => void;
  btnColor: string;
  btnName: string;
};

export default function ConfirmationBox({
  open,
  icon,
  title,
  isLoading,
  btnName,
  btnColor,
  close,
  handleAction,
}: ConfirmationBoxProps) {
  // HOOKS
  const { t } = useTranslation();

  return (
    <Dialog open={open} aria-labelledby="draggable-dialog-title">
      <DialogContent>
        <ReactSVG src={icon} />
        <span>{title}</span>
        {isLoading ? (
          <CircularProgress
            variant="indeterminate"
            disableShrink
            size={20}
            thickness={4}
            style={{ marginTop: 4, color: colors.lightBlue13 }}
            color="inherit"
          />
        ) : null}
      </DialogContent>
      <ActionButtons>
        <Button onClick={close} color={colors.darkGray05}>
          {t('screens.conversation.cancel')}
        </Button>
        <Button onClick={handleAction} color={btnColor}>
          {btnName}
        </Button>
      </ActionButtons>
    </Dialog>
  );
}
